import { Spinner } from '@fluentui/react-components';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { getAuthFromQueryClient } from '../lib/auth/hooks';
import { isCloudflareInternalPath } from '../lib/url-utils';

const LoginPage = lazy(() => import('../pages/LoginPage').then((m) => ({ default: m.LoginPage })));

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { redirectTo?: string } => {
    const redirectTo = typeof search.redirectTo === 'string' ? search.redirectTo : undefined;
    // Filter out Cloudflare Zero Trust internal paths (e.g., /cdn-cgi/access/login)
    // These paths are used by Cloudflare for authentication and should not be redirect targets
    if (redirectTo && isCloudflareInternalPath(redirectTo)) {
      return { redirectTo: undefined };
    }
    return { redirectTo };
  },
  beforeLoad: async ({ context }) => {
    const auth = await getAuthFromQueryClient(context.queryClient);

    // If user is authenticated, redirect to home
    if (auth?.user) {
      throw redirect({ to: '/' });
    }
  },
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <LoginPage />
    </Suspense>
  ),
});
